/**
 * HeroInstallCTA — V1.9.12
 *
 * A prominent "Get the NaukriDaddy app" callout designed to sit in the
 * landing-page hero. Auto-hides when the app is already installed or the
 * browser can't install (renders `null`), so it never becomes dead weight
 * on unsupported devices.
 *
 * On tap:
 *   • Chrome / Android / desktop Edge → native prompt via `promptInstall`
 *   • iOS Safari → shows the "Share → Add to Home Screen" walkthrough
 *     modal already implemented inside `InstallAppButton`.
 */

import React from "react";
import { DownloadSimple, DeviceMobile, Sparkle } from "@phosphor-icons/react";
import { InstallAppButton, shouldShowInstall } from "@/components/InstallPrompt";
import { useInstallState } from "@/lib/pwaInstall";

export default function HeroInstallCTA() {
    const state = useInstallState();
    if (!shouldShowInstall(state)) return null;

    return (
        <div
            data-testid="hero-install-cta"
            className="mt-6 inline-flex items-center gap-3 border border-splash/40 bg-splash/10 backdrop-blur-sm px-4 py-3 sm:pl-3 max-w-2xl"
        >
            <div className="w-10 h-10 shrink-0 bg-splash text-ink flex items-center justify-center">
                <DeviceMobile size={20} weight="bold" />
            </div>
            <div className="min-w-0 flex-1">
                <p className="text-[10px] font-black uppercase tracking-[0.25em] text-splash inline-flex items-center gap-1.5">
                    <Sparkle size={10} weight="fill" /> New
                </p>
                <p className="text-sm font-bold text-white leading-tight">
                    Install NaukriDaddy on your phone
                </p>
                <p className="text-[11px] text-white/60 mt-0.5 leading-snug">
                    Faster jobs, offline browsing, push updates.
                </p>
            </div>
            <InstallAppButton
                label="Install"
                testId="hero-install-cta-btn"
                className="shrink-0 inline-flex items-center gap-1.5 bg-splash hover:bg-splash/90 text-ink px-4 py-2 text-[11px] font-black uppercase tracking-wider transition-colors"
            />
        </div>
    );
}
